import React from "react";
import { convertTimestampToDate } from "../../../../utils";
import { projectStatus } from "../../../../utils";

export default function ProjectDetailsBox({ project }) {
  return (
    <div className="projectDetailsBox">
      <div className="projectDetailsHeader">Project Information</div>

      <div className="projectDetailRow">
        <div className="projectDetailColumn">
          <div className="projectDetailLabel">Posted By</div>
          <div className="projectDetailValue">
            {project.uploadedByData.displayName}
          </div>
        </div>
        <div className="projectDetailColumn">
          <div className="projectDetailLabel">Created On</div>
          <div className="projectDetailValue">
            {convertTimestampToDate(project.createdAt)}
          </div>
        </div>
      </div>

      <div className="projectDetailRow">
        <div className="projectDetailColumn">
          <div className="projectDetailLabel">
            {project.status === projectStatus.POSTED
              ? "Budget Range"
              : "Finalized Budget"}
          </div>
          <div className="projectDetailValue">
            {project.status === projectStatus.POSTED
              ? `${project.budget.from} to ${project.budget.to} SAR`
              : `${project.priceFinalized} SAR`}
          </div>
        </div>
        <div className="projectDetailColumn">
          <div className="projectDetailLabel">
            {project.status === projectStatus.POSTED
              ? "Location"
              : project.status === projectStatus.COMPLETE
              ? "Completed On"
              : "Location"}
          </div>
          <div className="projectDetailValue">
            {project.status === projectStatus.POSTED
              ? project.projectAddress
              : project.status === projectStatus.COMPLETE
              ? convertTimestampToDate(project.completedOn)
              : project.projectAddress}
          </div>
        </div>
      </div>

      <div className="projectDetailRow">
        <div className="projectDetailColumn">
          <div className="projectDetailLabel">
            {project.status === projectStatus.POSTED
              ? "Project Deadline"
              : project.status === projectStatus.COMPLETE
              ? "Project Duration"
              : "Project Deadline"}
          </div>
          <div className="projectDetailValue">
            {project.status === projectStatus.POSTED
              ? convertTimestampToDate(project.deadline)
              : project.status === projectStatus.COMPLETE
              ? `${Math.round(
                  (project.completedOn - project.createdAt) /
                    (1000 * 60 * 60 * 24)
                )} days`
              : convertTimestampToDate(project.deadline)}
          </div>
        </div>
        <div className="projectDetailColumn">
          {project.status === projectStatus.POSTED ? (
            <>
              <div className="projectDetailLabel">Proposal Deadline</div>
              <div className="projectDetailValue">
                {convertTimestampToDate(project.proposalDeadline)}
              </div>
            </>
          ) : (
            <>
              <div className="projectDetailLabel">Contractor</div>
              <div className="projectDetailValue">
                {project.merchFinalizedData.displayName}
              </div>
            </>
          )}
        </div>
      </div>

      {project.status === projectStatus.POSTED && (
        <div className="projectDetailRow">
          <div className="projectDetailColumn">
            <div className="projectDetailLabel">VAT Status</div>
            <div className="projectDetailValue">
              <span
                className={`vatStatus ${
                  project.vatIncluded ? "included" : "excluded"
                }`}
              >
                VAT {project.vatIncluded ? "Included" : "Not Included"}
              </span>
            </div>
          </div>
          <div className="projectDetailColumn">
            <div className="projectDetailLabel">Admin Status</div>
            <div className="projectDetailValue">
              <span
                className={`adminStatus ${
                  project.adminApproved ? "approved" : "pending"
                }`}
              >
                {project.adminApproved ? "Approved" : "Pending Approval"}
              </span>
            </div>
          </div>
        </div>
      )}

      <div className="projectDetailRow">
        <div className="projectDetailColumn" style={{ width: "100%" }}>
          <div className="projectDetailLabel">Description</div>
          <div className="projectDetailValue">{project.description}</div>
        </div>
      </div>

      {/* Project Images */}
      {project.projectImages && project.projectImages.length > 0 && (
        <div className="projectDetailRow">
          <div className="projectDetailColumn" style={{ width: "100%" }}>
            <div className="projectDetailLabel">Project Images</div>
            <div className="projectImagesGrid">
              {project.projectImages.map((image, index) => (
                <div key={index} className="projectImageContainer">
                  <img
                    src={image.url || image}
                    alt="Project"
                    className="projectImage"
                  />
                </div>
              ))}
            </div>
          </div>
        </div>
      )}

      <style jsx>{`
        .projectDetailsBox {
          background: #ffffff;
          border-radius: 12px;
          padding: 24px;
          margin-top: 24px;
          box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
          border: 1px solid #f0f0f0;
        }

        .projectDetailsHeader {
          font-size: 18px;
          font-weight: 600;
          color: #262626;
          margin-bottom: 24px;
          padding-bottom: 16px;
          border-bottom: 1px solid #f0f0f0;
        }

        .projectDetailRow {
          display: flex;
          gap: 24px;
          margin-bottom: 20px;
        }

        .projectDetailColumn {
          flex: 1;
        }

        .projectDetailLabel {
          font-size: 14px;
          color: #8c8c8c;
          margin-bottom: 8px;
        }

        .projectDetailValue {
          font-size: 15px;
          color: #262626;
          line-height: 1.5;
        }

        .vatStatus,
        .adminStatus {
          display: inline-flex;
          align-items: center;
          padding: 4px 12px;
          border-radius: 16px;
          font-size: 14px;
          font-weight: 500;
        }

        .vatStatus.included {
          background-color: #e6f7ff;
          color: #1890ff;
        }

        .vatStatus.excluded {
          background-color: #fff7e6;
          color: #fa8c16;
        }

        .adminStatus.approved {
          background-color: #f6ffed;
          color: #52c41a;
        }

        .adminStatus.pending {
          background-color: #fff7e6;
          color: #fa8c16;
        }

        .projectImagesGrid {
          display: flex;
          gap: 16px;
          margin-top: 12px;
          overflow-x: auto;
          padding-bottom: 8px;
          scrollbar-width: thin;
          scrollbar-color: #d9d9d9 #f0f0f0;
        }

        .projectImagesGrid::-webkit-scrollbar {
          height: 6px;
        }

        .projectImagesGrid::-webkit-scrollbar-track {
          background: #f0f0f0;
          border-radius: 3px;
        }

        .projectImagesGrid::-webkit-scrollbar-thumb {
          background-color: #d9d9d9;
          border-radius: 3px;
        }

        .projectImageContainer {
          flex: 0 0 120px;
          width: 120px;
          height: 120px;
          position: relative;
          border-radius: 8px;
          overflow: hidden;
          box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
        }

        .projectImage {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          object-fit: cover;
          transition: transform 0.3s ease;
        }

        .projectImageContainer:hover .projectImage {
          transform: scale(1.05);
        }
      `}</style>
    </div>
  );
}
